import { render, staticRenderFns } from "./CmgLoyaltyQuestions.vue?vue&type=template&id=4346e21d&scoped=true&lang=pug"
import script from "./cmg-loyalty-questions.ts?vue&type=script&lang=ts&external"
export * from "./cmg-loyalty-questions.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLoyaltyQuestions.vue?vue&type=style&index=0&id=4346e21d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346e21d",
  null
  
)

export default component.exports